import React, { useState } from 'react'
import cn from 'classnames'

import { ReactComponent as Chevron } from '../../../../assets/icons/chevron.svg'

import './DropdownButton.scss'

export const DropdownButton = ({
  listItems = [],
  selectedLabel,
  onChange,
}) => {
  const [show, setShow] = useState(false)

  return (
    <div className="dropdown-container">
      <div
        className={cn( 'wrapper', { show } )}
        onClick={() => setShow(false)}
      ></div>
      <button
        className="dropdown-button"
        onClick={() => setShow(v => !v)}
      >
        <span>
          { selectedLabel }
        </span>
        <Chevron />
      </button>
      <div className={cn( 'panel-container', { show } )}>
        {
          listItems.map((e, i) => (
            <button
              key={ i }
              className="item-button"
              onClick={() => {
                setShow(false)
                onChange(e.value)
              }}
            >
              { e.label }
            </button>
          ))
        }
      </div>
    </div>
  )
}